import { createFileRoute } from "@tanstack/react-router";

import { PortalHead, PortalPage } from "@/features/portal/components/portal-chrome";
import { ClosingBand } from "@/features/portal/components/closing-band";
import { FeaturesHero, FeaturesShowcase } from "@/features/portal/modules/features-page/features-page";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/features/")({
  head: () => ({ meta: pageMeta({ title: m.portal_nav_features(), description: m.seo_features_description() }) }),
  loader: () => ({ crumb: m.portal_nav_features() }),
  component: FeaturesPage,
});

/** What the app does, on its own page rather than only as bands of the front page. */
function FeaturesPage() {
  return (
    <PortalPage
      head={
        <PortalHead>
          <FeaturesHero />
        </PortalHead>
      }
    >
      <FeaturesShowcase />
      <ClosingBand />
    </PortalPage>
  );
}
